export function isInteger(value?: string) {
  if (!value) {
    return true;
  }
  const regexp = /^-{0,1}[0-9]+$/;

  return regexp.test(value);
}
